<template>
    <v-card>
        <v-toolbar :color="toolbarColor" density="compact">
            <div class="px-5 d-flex align-center w-100">
                <v-toolbar-title
                    :style="{
                        color: titleColor,
                        fontSize: titleFontSize,
                    }"
                >
                    <slot v-if="$slots.title" name="title" />
                    <template v-else>{{ cardTitle }}</template>
                </v-toolbar-title>
                <v-spacer />
                <slot v-if="$slots.status" name="status" />
            <span
                v-else-if="status"
                :style="{
                    color: statusColor(status),
                    'font-weight': 'bold',
                }"
            >
                {{ $t(`incidents.statusLabels.${status}`) }}
            </span>
            <span v-if="onResetPassword || onEdit || onDelete">
                <span v-if="onResetPassword">
                    <v-btn
                        icon
                        color="gray"
                        variant="plain"
                        elevation="0"
                        density="compact"
                        @click="onResetPassword"
                    >
                        <v-icon size="small">mdi-key-variant</v-icon>
                    </v-btn>
                    <v-tooltip activator="parent" location="bottom">
                        {{ $t("employeeView.resetPassword") }}
                    </v-tooltip>
                </span>
                <span v-if="onEdit">
                    <v-btn
                        icon
                        color="gray"
                        variant="plain"
                        elevation="0"
                        density="compact"
                        @click="onEdit"
                    >
                        <v-icon>mdi-account-box-edit-outline</v-icon>
                    </v-btn>
                    <v-tooltip activator="parent" location="bottom">
                        {{ $t("employeeView.editEmployee") }}
                    </v-tooltip>
                </span>
                <span v-if="onDelete">
                    <v-btn
                        icon
                        color="red"
                        variant="plain"
                        elevation="0"
                        density="compact"
                        @click="onDelete"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-tooltip activator="parent" location="bottom">
                        {{ $t("employeeView.deleteEmployee") }}
                    </v-tooltip>
                </span>
            </span>
            </div>
        </v-toolbar>
        <v-row no-gutters>
            <v-col class="px-5">
                <slot v-if="$slots.default" />
                <template v-else>
                    <v-list density="compact">
                        <v-list-item
                            v-for="(item, index) in bullets"
                            :key="index"
                            density="compact"
                            class="px-0"
                        >
                            <v-list-item-title v-html="item"></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </template>
            </v-col>
        </v-row>
        <slot v-if="$slots.actions" name="actions" />
    </v-card>
</template>
<script>
export default {
    name: "BulletCard",
    props: {
        titleColor: {
            type: String,
            default: "white", // default for primary toolbar
        },
        titleFontSize: {
            type: String,
            default: "16px",
        },
        toolbarColor: {
            type: String,
            default: "primary", // fallback/default color
        },
        /**
         * The title to display in the card header.
         * @type {String}
         */
        cardTitle: {
            type: String,
            required: true,
        },
        /**
         * An array of strings to display as bullet list items in the card content.
         * @type {Array}
         */
        bullets: {
            type: Array,
            required: true,
            default: () => [],
        },
        /**
         * An optional delete function.
         * @type {Function}
         */
        onDelete: {
            type: Function,
            default: null,
        },
        /**
         * An optional delete function.
         * @type {Function}
         */
        onEdit: {
            type: Function,
            default: null,
        },
        onResetPassword: {
            type: Function,
            default: null,
        },
        status: { type: String, default: null },
    },
    methods: {
        statusColor(s) {
            switch (s) {
                case "pending":
                    return "#FFFF00"; // yellow
                case "approved":
                    return "#4CAF50"; // Vuetify success
                case "declined":
                    return "#FF5252"; // Vuetify danger
            }
        },
    },
};
</script>
<style scoped>
.v-list-item-title {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-break: break-word;
}
</style>
